<script lang="ts">
	import { _ } from 'svelte-i18n';
	import type { Post } from '$lib/api/rpc';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import Footer from '$lib/components/Post/PostBlock/Blocks/Footer.svelte';
	export let block: Post;
	export let editable = false;
	import { page } from '$app/stores';
	// Since this can be rendered inside TipTap, we don't have access to the hubsStore
	const embedEnabled = !$page.data.respHub?.hub.settings.hide_file_embeds;
</script>

<div class="linkContainer">
	<header>
		<a class="openDocument" target="_blank" rel="noreferrer" href={block.source.url}>
			{$_('post.open.document')}
			<div class="icon">
				<Icon icon="next" />
			</div>
		</a>
	</header>
	{#if embedEnabled}
		<object
			title={block.title}
			data={block.source.url}
			type={block.mime}
			width="100%"
			height="500px"
		>
			<img
				height={block.title_image?.height}
				width={block.title_image?.width}
				src={block.title_image?.url}
				alt={block.title_image?.alt_text}
			/>
		</object>
	{:else}
		<img
			height={block.title_image?.height}
			width={block.title_image?.width}
			src={block.title_image?.url}
			alt={block.title_image?.alt_text}
		/>
	{/if}

	<svelte:element
		this={editable ? 'div' : 'a'}
		href={block.source.url}
		target="blank"
		rel="external"
	>
		<Footer {editable} {block} />
	</svelte:element>
</div>

<style>
	header {
		display: flex;
		place-items: center;
		flex-direction: row-reverse;
		border-block-end: 1px solid rgb(240 240 240);
	}

	.openDocument {
		display: flex;
		justify-content: center;
		inline-size: 30%;
		padding: var(--gutterMedium);
		text-decoration: none;
		border-inline-start: 1px solid rgb(240 240 240);
	}

	header :global(.openDocument *) {
		color: var(--hubLinkFontColor) !important;
	}

	header :global(.openDocument:hover *) {
		color: black !important;
	}

	.openDocument:hover {
		background-color: #fbfafa;
		color: black;
	}

	.icon {
		margin-inline-start: 4px;
		transform: rotate(-45deg);
	}

	img {
		block-size: 100%;
		inline-size: 100%;
		border-radius: 3px;
		object-fit: contain;
	}

	a {
		text-decoration: none;
	}
</style>
